module.exports = __webpack_public_path__ + "static/img/top.906552b2.webp";